<template>
  <div class="admin__a-tab-content admin__a-tab-content--show">
    <div class="a-container-form a-container-form--align-start">
      <div class="personal-data__btn-block admin-buy__block-gui-btn a-flex-start">
        <a href="#" id="sending-request" style="visibility: hidden"></a>
        <button class="gui-btn gui-btn--red gui-btn--w-278" type="button" :disabled="!lot.request.isFilled" v-if="lot.request.permissions.CAN_SEE_PUBLIC_LOT_SIGN_REQUEST" @click="onSignClick">{{$t('buttons.sign-request')}}</button>
        <button class="gui-btn gui-btn--red gui-btn--w-278" type="button" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_REMOVE_REQUEST && lot.request.permissions.CAN_REMOVE_REQUEST" @click="onRemoveClick">{{$t('buttons.delete-request')}}</button>
        <button class="gui-btn gui-btn--red gui-btn--w-278" type="button" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_REJECT_REQUEST && lot.request.permissions.CAN_REJECT_REQUEST" @click="onRejectClick">{{$t('buttons.reject-request')}}</button>
      </div>
    </div>

    <div class="a-container-form a-container-form--align-start" v-for="owner of lot.request.ownerHistory">
      <div class="a-label a-col-label a-label--w-280">Пользователь участника:</div>
      <div class="a-col-block-content u-line-height-23">
        <p class="a-input a-input--disabled">{{$t(owner.organization.type.label)}};</p>
        <p class="a-input a-input--disabled" v-if="owner.organization.type.ORGANIZATION">{{lot.request.owner.organization.name}};</p>
        <p class="a-input a-input--disabled">{{owner | fullName}};</p>
        <p class="a-input a-input--disabled">{{owner.phone}};</p>
        <p class="a-input a-input--disabled">{{owner.email}};</p>
        <p class="a-input a-input--disabled">{{$t(owner.status.label)}}</p>
        <p class="a-input a-input--disabled">
          До <date-time tag="span" :tz="false" :value="owner.time"></date-time>
        </p>
      </div>
    </div>

    <div class="a-container-form a-container-form--align-start" v-if="lot.request.owner">
      <div class="a-label a-col-label a-label--w-280">{{$t('form.lot.about-participant')}}:</div>
      <div class="a-col-block-content u-line-height-23">
        <p class="a-input a-input--disabled">{{$t(lot.request.owner.organization.type.label)}};</p>
        <p class="a-input a-input--disabled" v-if="lot.request.owner.organization.type.ORGANIZATION">{{lot.request.owner.organization.name}};</p>
        <p class="a-input a-input--disabled">{{lot.request.owner | fullName}};</p>
        <p class="a-input a-input--disabled">{{lot.request.owner.phone}};</p>
        <p class="a-input a-input--disabled">{{lot.request.owner.email}};</p>
        <p class="a-input a-input--disabled">{{$t(lot.request.owner.status.label)}}</p>
      </div>
    </div>

    <div class="a-container-form" v-if="lot.request.permissions.CAN_CHANGE_OWNER">
      <div class="a-label a-label--w-280">Назначить нового участника</div>
      <user-search subordinates v-model="owner"></user-search>
      <button class="gui-btn gui-btn--red u-margin-left-20"
              @click.prevent="onChangeOwnerClick">
        {{$t('buttons.save')}}
      </button>
    </div>

    <signing-dialog ref="signRequest"
                    @signed="signRequestAction">
    </signing-dialog>
  </div>
</template>

<script>
  import _ from 'lodash'
  import Errors from '@/api/types/errors'
  import Modal from '@/widgets/modal'
  import Dropdown from '@/widgets/dropdown'
  import SigningDialog from '@/components/common/dialogs/SigningDialog'
  import UserSearch from "@/components/common/inputs/UserSearch";

  export default {
    props: {
      lot: Object
    },

    components: {
      Modal, Dropdown, SigningDialog,
      UserSearch
    },

    data: () => ({
      finalAction: undefined,
      owner: undefined
    }),

    watch: {
      'lot.request.owner': {
        immediate: true,
        handler: function(owner) {
          this.owner = {
            id: _.get(owner, 'id'),
          }
        }
      }
    },

    methods: {
      async onSignClick() {
        this.runAction(async () => {
          try {
            const text = await this.$store.dispatch('getRequestPublishSigningText', { requestId: this.lot.request.id });
            this.finalAction = 'signRequest';

            if (this.lot.permissions.SHOULD_BE_SIGNED) {
              this.$refs.signRequest.open({text});
            }
            else {
              await this.signRequestAction();
            }
          }
          catch (e) {
            console.error('failed getting signing text for request', e);
            this.globalErrorHandler(e, {
              'BAD_PAYMENT_TYPE': 'errors.public-lot.signing-request.invalid-payment-type',
              'INVALID_STATE': 'errors.public-lot.signing-request.request-already-sent',
              'NOT_FILLED': 'errors.public-lot.signing-request.getting-request-period-finished',
              'ACCESS_DENIED': 'errors.public-lot.signing-request.access-denied'
            }, 'errors.public-lot.signing-request.unknown');
          }
        })
      },

      async onRemoveClick() {
        this.runAction(async () => {
          try {
            const text = await this.$store.dispatch('getRequestRemoveSigningText', { requestId: this.lot.request.id });
            this.finalAction = 'revokeRequest';

            if (this.lot.permissions.SHOULD_BE_SIGNED) {
              this.$refs.signRequest.open({text});
            }
            else {
              await this.signRequestAction();
            }
          }
          catch (e) {
            console.error('failed removing request', e);
            this.globalErrorHandler(e);
          }
        })
      },

      onChangeOwnerClick() {
        return this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('changeRequestOwner', { requestId: this.lot.request.id, owner: this.owner.id });
          }
          catch (e) {
            console.error('failed to change owner', e);
            this.globalErrorHandler(e);
          }
        })
      },

      async onRejectClick() {
        this.runAction(async () => {
          try {
            await this.$store.dispatch('rejectRequest', { requestId: this.lot.request.id });
          }
          catch (e) {
            console.error('failed rejecting request', e);
            this.globalErrorHandler(e);
          }
        })
      },

      async signRequestAction(result) {
        this.runAction(async () => {
          try {
            this.$refs.signRequest.close();

            await this.$store.dispatch(this.finalAction, {
              requestId: this.lot.request.id,
              text: result ? result.data : undefined,
              signature: result ? result.signature : undefined
            });

            if (this.finalAction === 'signRequest') {
              this.showError({
                title: 'Регистрация заявки',
                error: 'Ваша заявка зарегистрирована'
              });
            }

            this.finalAction = undefined;
          }
          catch (e) {
            console.error('failed publishing request', e);
            this.globalErrorHandler(e, {
              'BAD_SIGNATURE': 'errors.public-lot.sending-request.bad-signature',
              'BAD_PAYMENT_TYPE': 'errors.public-lot.sending-request.invalid-payment-type',
              'NOT_FILLED': 'errors.public-lot.sending-request.getting-request-period-finished',
              'ACCESS_DENIED': 'errors.public-lot.sending-request.access-denied',
              'INVALID_STATE': 'errors.public-lot.sending-request.request-already-sent',
              'INVALID_DATA': 'errors.public-lot.sending-request.cannot-update-data',
              'EXCEEDED_PRICE_LOW_THRESHOLD': 'errors.public-lot.sending-request.cost-exceeded-low-threshold',
              'TOO_HIGH_COST': 'errors.public-lot.sending-request.bid-cost-too-high'
            }, 'errors.public-lot.sending-request.unknown');
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
